var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { connectRouter, routerMiddleware } from "connected-react-router";
import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { createLogicMiddleware } from "redux-logic";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { accountReducer } from "./Account/reducers";
import { appStateReducer } from "./AppState/reducers";
import { cartReducer } from "./Cart/reducers";
import { clientsReducer } from "./Clients/reducers";
import { eventReducer } from "./Event/reducers";
import arrLogic from "./logic";
import { utilitiesReducer } from "./Utilities/reducers";
import { attendeeTypeReducer } from "./Attendees/reducers";
import { recordReducer } from "./Record/reducers";
import { postAttendeeActionsReducer } from "./PostAttendeeActions/reducers";
import { integrationsReducer } from "./Integrations/reducers";
var createAppReducer = function (history) {
    return combineReducers({
        app: appStateReducer,
        cart: cartReducer,
        accounts: accountReducer,
        clients: clientsReducer,
        events: eventReducer,
        router: connectRouter(history),
        utilities: utilitiesReducer,
        attendees: attendeeTypeReducer,
        record: recordReducer,
        postAttendeeActions: postAttendeeActionsReducer,
        integrations: integrationsReducer,
    });
};
var createRootReducer = function (history) { return function (state, action) {
    return createAppReducer(history)(state, action);
}; };
var persistConfig = {
    key: "root",
    storage: storage,
    blacklist: ["accounts", "app", "clients", "events", "cart", "attendees", "postAttendeeActions"],
};
var persistedReducer = function (history) { return persistReducer(persistConfig, createRootReducer(history)); };
export default function configureStore(history) {
    var logicDeps = {};
    //Disabling ts on this line helps us keep the rest of the actions strongly typed
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    var logicMiddleware = createLogicMiddleware(arrLogic, logicDeps);
    var middlewares = [logicMiddleware, routerMiddleware(history)];
    var middleWareEnhancer = applyMiddleware.apply(void 0, __spreadArray([], __read(middlewares), false));
    var store = createStore(persistedReducer(history), composeWithDevTools(middleWareEnhancer));
    var persistor = persistStore(store);
    return { store: store, persistor: persistor };
}
